import React, { useEffect, useState } from 'react';
import {
    Box, Card, CardContent, Typography, Button, Stack, Divider, FormControlLabel, Switch, ToggleButton, ToggleButtonGroup,
    FormHelperText, Grid
} from '@mui/material';
import FeeAmountInput from './FeeAmountInput';
import FeePreview from './FeePreview';
import { useDispatch } from 'react-redux';
import { fetchCreditCardSettings, updateCreditCardSettings } from '../../redux/slices/CreditCardFee';
import { useSelector } from 'react-redux';
import CommonLayout from 'layouts/DashboardLayout'
import { getPermissionsByMode } from "utilities/common";
import { hasSectionPermission } from "utilities/common";
import { getData } from "utilities/common";
import { openSnackbar } from "../../redux/slices/common";
import OrderSetting from './OrderSetting';

const CardSetting = () => {
    const dispatch = useDispatch();
    const { user = {} } = useSelector(state => state.auth)


    const [error, setError] = useState("")
    const [feeTypeError, setfeeTypeError] = useState("")
    const [feeError, setfeeError] = useState('')
    const [settings, setSettings] = useState({
        enabled: true,
        feeType: 'cash',
        creditCardFee: 0,
        feeLabel: 'Fee Applied',
        ccFlatFee: 0,
    });
    const [isEditing, setIsEditing] = useState(false);

    const handleLabelChange = (e) => {
        setSettings(prev => ({
            ...prev,
            feeLabel: e.target.value
        }));
        setIsDirty(true);
        setfeeError('')
    };

    const handleLabelClick = () => {
        setIsEditing(true);
        setIsDirty(true);
    };
    const handleLabelBlur = () => {
        setIsEditing(false);
    }
    const [isDirty, setIsDirty] = useState(false);


    const handleFeeAmountChange = (newAmount) => {
        setSettings(prev => ({
            ...prev,
            creditCardFee: newAmount
        }));
        setIsDirty(true);
        setError('')
    };
    const handleFlatFeeChange = (newFlatFee) => {
        setSettings(prev => ({
            ...prev,
            ccFlatFee: newFlatFee
        }));
        setIsDirty(true);
    };
    const handleToggleChange = (event) => {


        setSettings(prev => ({
            ...prev,
            enabled: event.target.checked,
        }));
        setIsDirty(true);
    };

    const handleSave = () => {
        setIsDirty(false);
        if (settings?.feeType === "") {
            setfeeTypeError("Fee Type is required");
            return
        }
        if (settings?.creditCardFee === 0) {
            setError("Credit Card Fee is required");
            return
        }
        if (settings?.feeLabel === "") {
            setfeeError("Fee Label is required");
            return
        }
        const payload = {
            "creditCardFee": settings?.creditCardFee,
            "storeId": user?.storeId,
            "enabled": settings?.enabled,
            "feeType": settings?.feeType,
            "ccReceiptHeading": settings?.feeLabel,
            "ccFlatFee": settings?.ccFlatFee
        }
        dispatch(updateCreditCardSettings(payload)).unwrap().then((res) => {
            showError(res?.message, 'success')

            dispatch(fetchCreditCardSettings(user?.storeId))
        }).catch((err) => {
            showError(err?.message, 'error')

        })

    };
    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }
    useEffect(() => {
        dispatch(fetchCreditCardSettings(user?.storeId)).unwrap().then((res) => {
            setSettings({
                enabled: res?.enabled,
                feeType: res?.feeType,
                creditCardFee: res?.creditCardFee,
                feeLabel: res?.ccReceiptHeading,
                ccFlatFee: res?.ccFlatFee || 0,
            })
        }).catch(() => { })

    }, [])



    const handleFeeTypeChange = (event, newValue) => {
        setSettings(prev => ({
            ...prev,
            feeType: event.target.value,
            // creditCardFee: 0,
            // ccFlatFee: 0,
        }));
        setfeeTypeError("")
        setIsDirty(true);
    };

    let localUser = getData("login-user-info");
    if (localUser) {
        localUser = JSON.parse(localUser);
    }

    const adminMode = localStorage.getItem("adminsMode")
        ? JSON.parse(localStorage.getItem("adminsMode"))
        : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);
    const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
    const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
    const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");


    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }}>
                <Grid container spacing={3} alignItems="flex-start">

                    {/* Credit Card Fee Settings */}
                    <Grid item xs={12} lg={6}>
                        <Card sx={{ p: 3, borderRadius: "0.75rem !important", boxShadow: "none" }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <Typography variant="h6" fontWeight={600} color="text.primary">
                                    Credit Card Fee Settings
                                </Typography>

                                <FormControlLabel
                                    control={<Switch checked={settings.enabled} onChange={handleToggleChange} />}
                                    label=""
                                    sx={{ m: 0 }}
                                />
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            <Box>
                                <Box sx={{ mb: 3 }}>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mb: 1 }}
                                    >
                                        Fee Type
                                    </Typography>
                                    <ToggleButtonGroup
                                        value={settings.feeType}
                                        exclusive
                                        onChange={(e) => handleFeeTypeChange(e)}
                                        aria-label="fee type"
                                        fullWidth
                                        sx={{
                                            '& .MuiToggleButtonGroup-grouped': {
                                                '&.Mui-selected': {
                                                    backgroundColor: 'primary.main',
                                                    color: 'white.main',
                                                    '&:hover': {
                                                        backgroundColor: 'primary.main',
                                                    },
                                                },
                                                p: 1,
                                                fontWeight: 500,
                                            },
                                        }}
                                    >
                                        <ToggleButton value="cash" aria-label="flat fee">
                                            Cash
                                        </ToggleButton>
                                        <ToggleButton value="percentage" aria-label="percentage">
                                            Percentage
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                    {
                                        feeTypeError && <FormHelperText error>{feeTypeError}</FormHelperText>
                                    }
                                </Box>

                                <FeeAmountInput
                                    value={settings.creditCardFee}
                                    onChange={handleFeeAmountChange}
                                    feeType={settings.feeType}
                                    ccFlatFee={settings.ccFlatFee}
                                    error={error}
                                    onFlatFeeChange={handleFlatFeeChange}
                                />

                                <FeePreview
                                    feeType={settings.feeType}
                                    creditCardFee={settings.creditCardFee}
                                    exampleAmount={50}
                                    feeLabel={settings?.feeLabel}
                                    feeError={feeError}
                                    isEditing={isEditing}
                                    handleLabelChange={handleLabelChange}
                                    handleLabelClick={handleLabelClick}
                                    ccFlatFee={settings?.ccFlatFee}
                                    handleLabelBlur={handleLabelBlur}
                                />

                                <Box
                                    component="footer"
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        mt: 2,
                                        gap: 2
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={handleSave}
                                        disabled={!isDirty || !canEdit}
                                        disableElevation
                                        sx={{
                                            opacity: isDirty ? 1 : 0.7,
                                            transition: 'all 0.2s',
                                            '&:not(:disabled):hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                            },
                                        }}
                                    >
                                        Save Changes
                                    </Button>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>

                    {/* Order Minimum Value */}
                    <Grid item xs={12} lg={6}>
                        <OrderSetting />
                    </Grid>

                </Grid>
            </Box>
        </CommonLayout>
    );
};

export default CardSetting;